// Display formatters for Log records (FEATURE_050).
// Wire format → UI text. No masking — logs ARE the audit record.

import type { AuditLogListItem } from '../types/log.types';

const pad = (n: number) => String(n).padStart(2, '0');

// KST (UTC+9). Log occurrences are recorded by BE in KST; createdAt is an
// ISO-8601 instant. The wire keeps the offset where present.
const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

function toKstParts(iso: string): {
  year: number; month: number; day: number;
  hours: number; minutes: number; seconds: number;
} | null {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  // Shift to KST: read UTC components from (utc + 9h).
  const k = new Date(d.getTime() + KST_OFFSET_MS);
  return {
    year: k.getUTCFullYear(),
    month: k.getUTCMonth() + 1,
    day: k.getUTCDate(),
    hours: k.getUTCHours(),
    minutes: k.getUTCMinutes(),
    seconds: k.getUTCSeconds(),
  };
}

// Display time as YYYY.MM.DD HH:MM:SS (KST, 24h, seconds).
export function formatLogTime(iso: string): string {
  const p = toKstParts(iso);
  if (!p) return iso;
  return `${p.year}.${pad(p.month)}.${pad(p.day)} ${pad(p.hours)}:${pad(p.minutes)}:${pad(p.seconds)}`;
}

// Returns the KST date portion (YYYY-MM-DD) of the wire ISO. Used by the mock
// filter to compare against `<input type="date">` values.
export function kstDateOf(iso: string): string {
  const p = toKstParts(iso);
  if (!p) return '';
  return `${p.year}-${pad(p.month)}-${pad(p.day)}`;
}

// User column shows "Name (Email)".
export function formatLogUser(entry: AuditLogListItem): string {
  return `${entry.actorName} (${entry.actorEmail})`;
}
